module.exports = __webpack_public_path__ + "static/media/vaccination_icon.bf341cbc.svg";